import { render, staticRenderFns } from "./modeloProntuario.vue?vue&type=template&id=45aeaa7f&scoped=true"
import script from "./modeloProntuario.vue?vue&type=script&lang=js"
export * from "./modeloProntuario.vue?vue&type=script&lang=js"
import style0 from "./modeloProntuario.vue?vue&type=style&index=0&id=45aeaa7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aeaa7f",
  null
  
)

export default component.exports